import Cookies from 'js-cookie';

class Collapse {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-toggle="custom-collapse"]',
			namespace: '',
			group: '',
		}, config);

		this.$scope = $(this.config.scope);
		this.$group = $(this.config.group);

		if (this.$scope.length > 0 || this.$group.length > 0) {
			this.init();
		}
	}

	init() {
		$(document)
			.off(`.${this.config.namespace}`)
			.on(`click.${this.config.namespace}`, `${this.config.group} ${this.config.scope}`, this.toggleCollapse.bind(this));
	}

	toggleCollapse(event) {
		let $button = $(event.currentTarget);
		let $target = $(event.target);

		if ($target.attr('data-info') != undefined || $target.closest('[data-info]').length > 0) {
			return;
		}

		let isClosed = $button.attr('aria-expanded') == 'false';
		if (isClosed) {
			this._open($button);
			return;
		}

		this._close($button);
	}

	_openByIndex(index, closePrevious = false) {
		let $button = $(`${this.config.group} ${this.config.scope}[data-index="${index}"]`);
		let $prev = $(`${this.config.group} ${this.config.scope}[data-index="${index - 1}"]`)

		if ($prev.length > 0 && closePrevious) {
			this._close($prev);
		}

		if ($button.length < 1) {
			return;
		}

		this._open($button);
	}

	_open($button) {
		let collapse = bootstrap.Collapse.getOrCreateInstance($button.data('bs-target'), {
			toggle: false
		});
		$button.attr('aria-expanded', 'true');
		collapse.show();

		let cookie = $button.data('cookie');
		if (!cookie) {
			return false;
		}

		let cookies = this._getCookie();
		cookies[cookie] = true;
		this._setCookie(cookies)
	}

	_close($button) {
		let collapse = bootstrap.Collapse.getOrCreateInstance($button.data('bs-target'), {toggle: false});
		$button.attr('aria-expanded', 'false');
		collapse.hide();

		let cookie = $button.data('cookie');
		if (!cookie) {
			return false;
		}

		let cookies = this._getCookie();
		cookies[cookie] = false;
		this._setCookie(cookies);
	}

	_setCookie(value) {
		Cookies.set('collapse', JSON.stringify(value));
	}

	_getCookie() {
		let cookies = Cookies.get('collapse') ?? '{}';
		return JSON.parse(cookies);
	}
}

export default Collapse;